import { createElement } from 'react';
import Advanced from './Advanced';
import Basic from './Basic';

const ContentLearningLibrary = ({ advanced, ...props }) =>
  createElement(advanced ? Advanced : Basic, props);

ContentLearningLibrary.defaultProps = {
  advanced: false,
};

export default ContentLearningLibrary;
